"use client";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const ProductImage = ({ product }) => {
  return (
    <div className="w-80 space-y-2.5">
      <LazyLoadImage
        src={product?.images?.[0]}
        alt={product?.title}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = `https://placehold.co/600x900?text=${product?.title}`;
        }}
        effect="blur"
        className="w-full object-contain text-sm"
      />
    </div>
  );
};

export default ProductImage;
